/***************Enum Constants***************/

import { Messages } from './message.constant';

export enum AppEnv {
  Local = 'local',
  Feature = 'feature',
  Dev = 'development',
  Demo = 'demo',
  Stage = 'stage',
  QA = 'qa',
  Production = 'production'
}

export enum HttpHeader {
  ContentType = 'Content-Type',
  ApiKey = 'x-api-key',
  Token = 'access-token'
}
export enum HrmGroup {
  DC_EVENTS = 'DC Events',
  DC_INVENTORY = 'DC Inventory',
  DC_MANAGEMENT = 'DC Management'
}


export enum RequestHeaders {
  ContentType = 'Content-Type',
  ApiKey = 'x-api-key',
  Token = 'Transaction-Token'
}

export enum ResponseHeaders {
  Token = 'Transaction-Token',
  RefreshToken = 'refresh'
}

export enum ErrorNotificationType {
  Toast = 'TOASTER',
  Page = 'PAGE',
  Modal = 'MODAL'
}

export enum ErrorConfig {
  SysErrId = 'SYS100',
  BadRequestId = 'SYS400',
  NotFoundId = 'SYS404',
  PreconditionRequiredId = 'SYS428',
  TimeoutId = 'UI408'
}


export enum Configuration {
  API_KEY = 'apiKey',
  UNDER_MAITENANCE = 'appDown',
  USER_API_ENDPOINT = 'userApiEndpoint',
  CONFIG_API_ENDPOINT = 'configApiEndpoint',
  ORDER_API_ENDPOINT = 'orderApiEndPoint',
  AUTH_API_ENDPOINT = 'authApiEndPoint',
  LOGIN_API_ENDPOINT = 'loginApiEndPoint'
}

export enum LogLevel {
  TRACE = 'trace',
  DEBUG = 'debug',
  INFO = 'info',
  LOG = 'log',
  WARN = 'warn',
  ERROR = 'error',
  FATAL = 'fatal',
  OFF = 'off'
}

export enum EncDecAlgo {
  AES = 'AES',
  DES = 'DES',
  TripleDES = 'TripleDES',
  RC4 = 'RC4',
  RC4Drop = 'RC4Drop',
  Rabbit = 'Rabbit',
  RabbitLegacy = 'RabbitLegacy',
  EvpKDF = 'EvpKDF'
}

export enum CancelOperation {
  Cancel = 1,
  UndoCancel = 2,
  None = 3
}

export enum ModalReasons {
  Yes = 'YES',
  No = 'No',
  Cancel = 'CANCEL',
  Close = 'CLOSE'
}

export const Page = {
  Current: 1,
  Size: 10,
};

export const DateFormat = {
  Default: 'M/DD/YYYY h:mm:ss A',
  MMDDYYYY: 'MM/DD/YYYY',
  YYYYMMDD: 'YYYY-MM-DD',
  MMDDYYYYHMMA: 'MM/DD/YY H:MM A'
};

export enum DatePickerPlacement {
  Default = 'bottom',
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left'
}

export enum Operation {
  Create = 1,
  Detail = 2
}

export enum FilterType {
  Default = 'StartsWith',
  StartsWith = 'StartsWith',
  Contains = 'Contains'
}

export enum SortDirection {
  Default = 'asc',
  Asc = 'asc',
  Desc = 'desc'
}

export enum ExampleEnum {
  SIMPLE = 'simple',
  MINMAX = 'minmax',
  NESTED = 'nested',
  IFRAME = 'iframe',
  TRANSITION = 'transition',
  SYNC = 'sync',
  STYLE = 'style',
  TOGGLE = 'toggle',
  CLICK = 'click',
  CODE = 'code',
  GEEK = 'geek',
  DIR = 'dir',
  WORKSPACE = 'workspace',
  LAZY = 'lazy',
}

export enum OktaOperationSource {
  ForgotPassword = 'FORGOT_PASSWORD',
  ResetPassword = 'PASSWORD_RESET',
  ActivateUser = 'WELCOME',
  ActivateNonMigrateUser = 'ACTIVATE_NON_MIGRATE_USER',
  UnlockAccount = 'UNLOCK_ACCOUNT',
  SecurityQuestion = 'SECURITY_QUESTION'
}

export enum OktaErrorCodes {
  Auth_Failed = 'E0000004'
}

export enum OktaOperationType {
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
  ActivateUser = 'activate-user',
  ActivateNonMigrateUser = 'activate-non-migrate-user',
  UnlockAccount = 'unlock-account'
}

export enum CacheConstant {
  Okta_Operation = 'user-operation',
  User_Auth_Detail = 'user-auth-details',
  Auth_Tokens = 'auth-tokens',
  Static_Data = 'static-data',
  Temp_Credit_Cards = 'temp-credit-cards',
  Order_Review = 'review-order',
  Order_Submit = 'submit-order',
  Payment_Method = 'payment-method',
  Search_Tracker = 'search-tracker',
  Invoice_Number = 'invoice-number',
  Order_Number = 'order-number',
  Order_History_Detail = 'order-history-detail',
  Okta_Session_Id = 'session-id',
  User_Id = 'user-id',
  Substitute_Data = 'substitute-data',
  Okta_Authenticated = 'okta-authenticated',
  Store_Location = 'store-location',
  Expired_Password = 'expired-password',
  Search_Route = 'search-route',
  Catalog_Data = 'catalog-data',
  Favourite_List_Data = 'favourite-List-data',
  User_Permission = 'user-permission',
  Message_Detail = 'message-detail'
}

export enum CacheDuration {
  Default = 60 * 60 * 8,
  OneMinute = 60 * 1,
  OneHour = 60 * 60 * 1,
  TwoHour = 60 * 60 * 2
}

export const DateTimeFormat = {
  DATE_TO_SEND: 'YYYY-MM-DD',
  DATE_IN_YYYYMMDD: 'YYYYMMDD',
  DATE_TO_DISPLAY: 'MM/DD/YYYY',
  DATE_TIME: 'MM/DD/YY HH:mm:ss',
  UTC_DATE_TIME: 'MM/DD/YY HH:mm:ssZ',
  TIME_ZONE: 'America/New_York',
  LOCALE_DATE_TIME: 'en-US',
  DATE_TIME_TO_DISPLAY: 'MM/DD/YYYY hh:mm A',
  DATE_TIME_REQUEST_FORMAT: 'MM/DD/YYYY HH:mm',
  MMDDYYYYHHMMSS: 'MM-DD-YYYY HH:mm:ss',
  MMDDYYYY: 'MM-DD-YYYY',
  FILE_DOWNLOAD_FORMAT: 'MM_DD_YYYY',
  DATE_TIMEIN_MINUTE: 'MM/DD/YYYY hh:mm'
};

export enum DateTimeOptions {
  EstTimeZone = 'America/New_York',
  DateTimeFormat = 'YYYY-MM-DD HH:mm',
  DateTimeWithZone = 'YYYY-MM-DD HH:mmZ',
  TimeFormat = 'hh:mm A',
  DateFormat = 'MM-DD-YYYY',
}

export enum ErrorResponseMessageType {
  Toastr = 'TOASTER',
  Page = 'PAGE',
  Modal = 'MODAL'
}

export enum Base64Prefix {
  GIFImagePrefix = 'data:image/gif;base64,', 
  CSVPrefix = 'data:text/csv;base64,',
}


/***************Enum Constants***************/
export const AppConstant = {
  BuId: 3,
  Type: 'KinrayAdmin',
  CustomerServiceNumber: '718.767.1234',
};

export const AppMessages = {
  SessionExpiredTitle: 'Session Expired',
  GenericErrorMessage: Messages.GENERAL_API_ERROR,
};

export const HttpErrorMessages = {
  SYS100: AppMessages.GenericErrorMessage,
  SYS400:
    'Bad request. Please refresh your browser and try again. ' +
    'If the problem persists, please contact our customer service department at ' +
    AppConstant.CustomerServiceNumber +
    '.',
  SYS404:
    'The resource you are looking forward does not exit. Please contact our customer service department at ' +
    AppConstant.CustomerServiceNumber +
    '.',
  SYS412:
    'Requested resource is either not exist or modified by some other user. Please refresh your view. If the problem persists, please contact our customer service department at ' +
    AppConstant.CustomerServiceNumber +
    '.',
  UI408:
    'Request has timed out. Please try again. If the problem persists, please contact our customer service department at ' +
    AppConstant.CustomerServiceNumber +
    '.',
};

export const HttpStatusCode = {
  Timeout: -1,
  NoContent: 204,
  BadRequest: 400,
  UnAuthorized: 401,
  NotFound: 404,
  PreconditionRequired: 412,
};

export const ExceptionCode = {
  SEC04: 'SEC04',
  AUT004: 'AUT004',
  USR005: 'USR005',
  E0000007: 'E0000007',
  E0000016: 'E0000016',
  E0000038: 'E0000038',
  USR024: 'USR024',
};

// Password: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[-!"#\$%\&'\(\)*+,./:;<=>\?@\[\]])(?=\S+$).{6,}$/,
export const Regex = {
  RestrictSpecialChars: /[^A-Za-z0-9:;<=>?\^{}|~!'#$%&'()*+,.`_@\-\[\]\/\\ ]/g,
  AlphaNumericOnly: /^[a-zA-Z0-9 ]*$/,
  Password: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[-!"#\$%\&'\(\)*+,./:;<=>\?@\[\]])(?=\S+$).{6,}$/,
  Email: /.{1,}@.{1,}\..{1,}/,
  Phone: /[0-9]{10}/,
  Date: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/,
  Time: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
};

export const DefaultData = {
  BusinessUnit: 'N.A.',
  Division: 'N.A.',
  AccountName: 'N.A.',
  Generic: 'N.A.'
};

export const UserProperty = {
  Detail: 'detail',
  RolePermissions: 'permissions'
};

export const EXTERNAL_USER_ROLES = [7, 8];

export const ActionButton = {
  Cancel: 'Cancel',
  UndoCancel: 'Undo Cancel',
  CancelUndoCancel: 'Cancel/Undo Cancel'
};

export const MessageFormatter = {
  Count: '{{count}}'
};

export const RequestParams = {
  SeasonNum: 'seasonNum'
};

export const StatusCardKeys = {
  Units: 'Units',
  Allocations: 'Allocations'
};

export const StatusCardCode = {
  Total: -1
};
